
import ClearIcon from "@mui/icons-material/Clear";
import LaunchIcon from "@mui/icons-material/Launch";
import DescriptionIcon from "@mui/icons-material/Description";
import { Delete, Launch } from "@mui/icons-material";

import CloseIcon from "@mui/icons-material/Close";
import {
    Box,
    Breadcrumbs,
    Button,
    Card,
    CardActions,
    CardContent,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    IconButton,
    InputLabel,
    Link,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Stack,
    Tab,
    Tabs,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import { DYNAMIC_URL_REGEX } from "../../../../constants";
import { ImageUrlDisplay } from "./MediaPreview";


export const MediaDisplay = ({ mediaUrl, fileName, disabled, handleRemoveMedia }) => {

    const handleOpenMedia = () => {
        if (mediaUrl) {
            window.open(mediaUrl, "_blank", "noopener,noreferrer");
        }
    };
    if (!fileName && !mediaUrl) {
        return null;
    }


    return (
        <>
            {mediaUrl.match(DYNAMIC_URL_REGEX) ?
                <Card style={{ padding: "0px", marginBottom: "10px" }}>
                    <CardContent
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            paddingLeft: "10px",
                            paddingRight: "0px",
                        }}
                    >
                        {!disabled && <Grid sx={{ alignItems: "center", textAlign: "end" }}>
                            <IconButton size="large" style={{ margin: "0px" }} onClick={() => handleRemoveMedia()}>
                                <ClearIcon className="text-danger " />
                            </IconButton>
                        </Grid>}
                        <Grid className="p-1 border">
                            <ImageUrlDisplay formikImage={{ url: mediaUrl }} />
                        </Grid>
                    </CardContent>
                </Card>
                :
                <Stack spacing={2} sx={{ width: "100%" }}>
                    {/* Chip with delete functionality */}

                    {/* Enhanced file display card */}
                    <Paper
                        elevation={1}
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            border: "1px solid",
                            borderColor: "divider",
                            transition: "all 0.2s ease-in-out",
                            "&:hover": {
                                borderColor: "primary.main",
                                boxShadow: 2,
                            },
                        }}
                    >
                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                            {/* File info section */}
                            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flex: 1 }}>
                                <DescriptionIcon color="action" />
                                <Typography
                                    variant="body2"
                                    color="text.primary"
                                    noWrap
                                    sx={{
                                        flex: 1,
                                        fontWeight: 500,
                                    }}
                                >
                                    {fileName || "PDF file"}
                                </Typography>
                            </Stack>

                            {/* Action buttons */}
                            <Stack direction="row" spacing={1}>
                                <Tooltip title="Open file">
                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={handleOpenMedia}
                                        disabled={!mediaUrl}
                                        sx={{
                                            "&:hover": {
                                                backgroundColor: "primary.light",
                                                color: "primary.contrastText",
                                            },
                                        }}
                                    >
                                        <LaunchIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Remove file">
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={handleRemoveMedia}
                                        disabled={disabled}
                                        sx={{
                                            "&:hover": {
                                                backgroundColor: "error.light",
                                                color: "error.contrastText",
                                            },
                                        }}
                                    >
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </Stack>
                    </Paper>

                    {/* Alternative compact view */}
                </Stack>}
        </>
    );
};
